import { render, staticRenderFns } from "./ShoplistCategory.vue?vue&type=template&id=0851cf3d&"
import script from "./ShoplistCategory.vue?vue&type=script&lang=js&"
export * from "./ShoplistCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0851cf3d')) {
      api.createRecord('0851cf3d', component.options)
    } else {
      api.reload('0851cf3d', component.options)
    }
    module.hot.accept("./ShoplistCategory.vue?vue&type=template&id=0851cf3d&", function () {
      api.rerender('0851cf3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ShoplistCategory.vue"
export default component.exports